import {ActionTypeLoggingAccessEnum} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import React from 'react';
import {LayoutContainer} from '../../components/LayoutContainer';
import {useMyHospitalizationLoggingAccess} from '../../hooks/useMyHospitalizationLoggingAccess';
import {BullishForecastAlert} from './components/BullishForecastAlert';
import {CardsGrid} from './components/CardsGrid';
import {ConciergeBanner} from './components/ConciergeBanner';
import {HeaderHomeHospitalization} from './components/Header';
import {BannersMyHospitalizationHome} from './components/Banners';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const MyHospitalizationHome = () => {
	useMyHospitalizationLoggingAccess(ActionTypeLoggingAccessEnum.HOME);

	const {isEnabled: isMyHospitalizationBannerFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_INTERNACAO_BANNER,
	);

	return (
		<LayoutContainer>
			<HeaderHomeHospitalization />
			<BullishForecastAlert />
			<ConciergeBanner />
			<CardsGrid />
			{isMyHospitalizationBannerFeatureFlagEnabled && <BannersMyHospitalizationHome />}
		</LayoutContainer>
	);
};
